<script setup lang="ts">
import { FormRow } from '@shared/ui/form-row'
import { RadioItem } from '@shared/ui/radio'

import { useTutorApplicationStore } from '../../model/store'
import { useAgeConfirmation } from '../../model/additional-questions/age-confirmation.hooks'
import { yesNoOptions } from '../../config/additional-questions'

defineOptions({
  name: 'AgeConfirmation',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  setAgeConfirmation,
} = useAgeConfirmation()

</script>

<template>
  <FormRow
    label="I am 18 years old or older"
    :required="true"
  >
    <RadioItem
      v-for="option in yesNoOptions"
      :key="option.value.toString()"
      :checked="tutorApplicationStore.form.ageConfirmation === option.value"
      :label="option.label"
      :mode="mode"
      @click="setAgeConfirmation(option.value)"
    />
  </FormRow>
</template>
